;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.Coach = Backbone.Model.extend({
		url: '',
		defaults: {
			id: 0,
			first_name: '',
			last_name: '',
			team_name: ''
		}
	});

}(window, APP, Backbone, Marionette, $, _));
